<div class="surface-card p-4 shadow-2 border-round">
  <ng-template [ngIf]="isLoadingResults">
    <app-loading></app-loading>
</ng-template>
    <div class="mb-3 flex md:flex-row align-items-center md:justify-content-between justify-content-between ">
      <div class="flex justify-start md:justify-start">
          <span class="p-input-icon-left mr-2">
            <i class="pi pi-search"></i>
            <input type="text" pInputText placeholder="Cerca" (input)="filtraODA($event)" [disabled]="isLoadingResults" />
          </span>
          <div class="flex align-items-center ">
            <p-inputSwitch [(ngModel)]="mostraOdaCompletati" (ngModelChange)="onMostraCompletatiChange($event)"></p-inputSwitch>
            <span class=" ml-2 text-900">Mostra completati</span>
          </div>
          <button *ngIf="filterIsSet" pButton type="button" icon="pi pi-filter-slash" class="ml-2"
            style="background-color: #809cd4; border-color:#191a1b; color: #f9f9f9;font-size: 13px;" (click)="removeFilter()"
            pTooltip="Rimuovi filtro" tooltipPosition="top" 
          ></button>
         
      </div>
      <div class="flex justify-end md:justify-center">
        <span class="text-xl font-medium text-2000 font-['Poppins']" style="color: #6c092c">ORDINI DI ACQUISTO</span>
      </div>
      
      <div class="flex justify-end md:justify-end">
        <button 
            pButton type="button" icon="pi pi-cloud-download"
            pTooltip="Scarica export" tooltipPosition="top"
            class="font-['Poppins'] mr-3"
            style="background-color:#ffffff; color: #3d64b3; border-color: #3d64b3; font-size: 13px;"
            label="Scarica report"
            (click)="scaricaReportOda()" [disabled]="isLoadingResults"
        ></button>
        <button *ngIf="!this.isDirigenteFirmaPacchetti" pButton type="button" icon="pi pi-plus" pTooltip="Crea nuovo ODA" tooltipPosition="top"
          class="font-['Poppins']"
          style="background-color:#ffffff; color: cadetblue; border-color: cadetblue; font-size: 13px;" label="Nuovo"
          (click)="openCreaODADialog()" [disabled]="isLoadingResults"
          [disabled]="isDemo">
        </button>
      </div>

    </div>
 
 <!--[sortField]="'numero'" [sortOrder]="1"-->
            <div fxFlex="95%" class="mt-2">
                <p-table #odaDT styleClass="p-datatable-sm" [loading]="isLoadingResults" [value]="listaODA" dataKey="id" [(selection)]="selectedODA"
                [selectionPageOnly]="true" [rowHover]="true" [rows]="10" [showCurrentPageReport]="true"
                [rowsPerPageOptions]="[10,25,50]" responsiveLayout="scroll" [paginator]="true"
                currentPageReportTemplate="{first} - {last} di {totalRecords}" [filterDelay]="0"
                [globalFilterFields]="['numero','bando','azienda','importo', 'lotto']"
                >

                <ng-template pTemplate="header">
                  <tr>
                   <th class="text-center font-['Poppins']" style="font-size: 12px;">Azioni</th>
                   <th  pSortableColumn="numero" style="font-size: 12px;">
                        NUMERO
                    </th>
                    <th class="text-center font-['Poppins']" style="font-size: 12px;">
                        IMPRESA
                    </th>
                    <th class="text-center font-['Poppins']" style="font-size: 12px;">
                        BANDO
                    </th>
                    <th class="text-center font-['Poppins']" style="font-size: 12px;">
                        LOTTI
                    </th>
                    
                   <!--  <th class="text-center font-['Poppins']" style="font-size: 12px;">
                        REFERENTE TIM
                     </th> -->
                     <th class="font-['Poppins']" pSortableColumn="dataCreazione" style="font-size: 12px;">
                      <div class="flex justify-content-between align-items-center">
                        DATA CREAZIONE
                        <p-sortIcon field="dataCreazione"></p-sortIcon>
                      </div>
                    </th>
                    <th class="font-['Poppins']" pSortableColumn="importo" style="font-size: 12px;">
                      <div class="flex justify-content-between align-items-center">
                        IMPORTO
                        <p-sortIcon field="importo"></p-sortIcon>
                      </div>
                    </th>
                    <th class="font-['Poppins']" pSortableColumn="importoImpegnato" style="font-size: 12px;">
                      <div class="flex justify-content-between align-items-center">
                        IMPEGNATO
                        <p-sortIcon field="importoImpegnato"></p-sortIcon>
                      </div>
                    </th>
                    <th class="font-['Poppins']" pSortableColumn="importoEMEmesse" style="font-size: 12px;">
                      <div class="flex justify-content-between align-items-center">
                        DOVUTO
                        <p-sortIcon field="importoEMEmesse"></p-sortIcon>
                      </div>
                    </th>
                    <th class="font-['Poppins']" pSortableColumn="importoEMEmesse" style="font-size: 12px;">
                      <div class="flex justify-content-between align-items-center">
                        PAGATO
                        <p-sortIcon field="importoEMEmesse"></p-sortIcon>
                      </div>
                    </th>
                    <th class="font-['Poppins']" pSortableColumn="percentualeResidua" style="font-size: 12px;">
                      <div class="flex justify-content-between align-items-center">
                        % RESIDUA
                        <p-sortIcon field="percentualeResidua"></p-sortIcon>
                      </div>
                    </th>
                  </tr>
                </ng-template>

                <ng-template pTemplate="body" let-row>
                    <tr>
                      <td class="text-center" style="width: 10px;">
                        <button 
                          pButton type="button" style="color:rgb(39, 128, 15)"
                          icon="pi pi-ellipsis-v" class="p-button-rounded p-button-text" 
                          (click)="openCaricaAzioni($event,row)">
                        </button> 
                      </td>
                      <td > <span class="text-uppercase font-semibold font-['Poppins']" style="font-size: 13px; font-weight: 400; ">{{row.numero}}</span> </td>
                      <td class="text-center font-['Poppins']"> 
                        <p-tag
                                [value]="row.azienda | uppercase"
                                [style]="{
                                  'background-color': '#326F6F' ,
                                  'color': '#ffffff' ,
                                  'border-radius': '6px',
                                  'padding': '.25em .5rem',
                                  'font-weight': '700',
                                  'font-size': '12px',
                                  'letter-spacing': '.3px;',
                                  'cursor': 'pointer',
                                }"
                                 (click)="filtraPerAzienda(row.azienda)"
                                 [pTooltip]="filterIsSet?'ELimina filtro':'Filtra su '+ row.azienda"
                                  tooltipPosition="top"
                            ></p-tag>
                       </td>
                      <td class="text-center font-['Poppins']">   
                        <p-tag
                              [value]="row.bando | uppercase"
                              [style]="{
                                'background-color': row.bando==='BANDO 1'?'cadetblue':'cornflowerblue' ,
                                'color': '#ffffff' ,
                                'border-radius': '6px',
                                'padding': '.25em .5rem',
                                'font-weight': '700',
                                'font-size': '12px',
                                'letter-spacing': '.3px;',
                                'cursor': 'pointer',
                              }"
                              (click)="filtraPerBando(row)"
                              [pTooltip]="filterIsSet?'ELimina filtro':'Filtra su '+ row.bando"
                              tooltipPosition="top"
                              
                          ></p-tag>
                       </td>
                      <td class="text-center font-['Poppins']"> 
                        <p-tag *ngFor="let lotto of row.lotti"
                              [value]="lotto"
                              [style]="{
                                'background-color': '#EBC66B' ,
                                'color': '#ffffff' ,
                                'border-radius': '6px',
                                'padding': '.25em .5rem',
                                'font-weight': '700',
                                'font-size': '11px',
                                'letter-spacing': '.3px;',
                                'cursor': 'pointer',
                              }"
                                  class="mr-1"
                                  (click)="filtraPerLotto(lotto)"
                                  [pTooltip]="filterIsSet?'ELimina filtro':'Filtra su '+lotto"
                                  tooltipPosition="top"
                        ></p-tag>
                      </td>
<!--                         <td class="text-center font-['Poppins']"> <span class="text-uppercase" style="font-size: 13px; font-weight: 300; ">{{row.referenteTIM}}</span> </td>
 -->                  <td class="text-center font-['Poppins']"> <span class="text-uppercase" style="font-size: 13px; font-weight: 300; ">{{utilService.formattaDataDaTimestampFirestore(row.dataCreazione)}}</span> </td>
                      <td class="text-right font-['Poppins']"> <span class="text-uppercase" style="font-size: 13px; font-weight: 400; font-weight: bold;" >{{row.importo | formattaNumero }} €</span> </td>
                      <td class="text-right font-['Poppins']"> <span class="text-uppercase" style="font-size: 13px; font-weight: 500; ">{{row.importoImpegnato | formattaNumero}} €</span> </td>
                      <td class="text-right font-['Poppins']"> <span class="text-uppercase" style="font-size: 13px; font-weight: 500; ">{{getImportoDovuto(row) | formattaNumero}} €</span> </td>
                      <td class="text-right font-['Poppins']"> <span class="text-uppercase" style="font-size: 13px; font-weight: 500; ">{{row.importoEmEmesse | formattaNumero}} €</span> </td>
                      <td class="text-center font-['Poppins']"> 
                        <span class="text-uppercase font-bold" style="font-size: 14px; font-weight: 500;" [style]="{'color':row.percentualeResidua<=10?'red':'green'}" 
                        pTooltip="Calcolata sull'importo delle EM emesse"
                        tooltipPosition="top"
                        >{{row.percentualeResidua}} %</span> 
                      </td>
                    
                       
                      </tr>
                </ng-template>
              </p-table>
             <!--  <p-menu #menuAzioni [popup]="true" [model]="menuAzioniItems"></p-menu> -->
              <p-tieredMenu #menuAzioniTiered [popup]="true" [model]="menuAzioniItems"></p-tieredMenu>
            </div>
		</div>

 <p-dialog [(visible)]="showDeleteConfirmation" appendTo="body" [modal]="true" [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '40vw'}" [closable]="false" [showHeader]="false">
    <div class="flex flex-column align-items-center my-4">
        <span class="flex align-items-center justify-content-center bg-cyan-100 text-cyan-800 mr-3 border-circle mb-3" style="width:64px;height:64px">
            <i class="pi pi-trash text-5xl"></i>
        </span>
        <div class="font-medium text-2xl text-900">ELIMINAZIONE</div>
    </div>
    <p class="line-height-3 p-0 m-0">
       Confermi di voler eliminare l'ordine di acquisto <span style="font-weight: bold;">{{selectedODA?selectedODA.numero:''}}</span> dell'impresa <span style="font-weight: bold;">{{selectedODA?selectedODA.azienda.toUpperCase():''}}</span>?
    </p>
    <ng-template pTemplate="footer">
        <div class=" border-top-1 surface-border pt-3 flex">
            <button pButton pRipple icon="pi pi-times" styleClass="p-button-success" (click)="showDeleteConfirmation = false" label="ANNULLA" class="p-button-outlined w-6 mr-2"></button>
            <button pButton pRipple icon="pi pi-check" styleClass="p-button-warning" (click)="confermaEliminazioneOda()" label="CONFERMA" class="w-6 ml-2"></button>
        </div>
    </ng-template>
</p-dialog> 
<p-dialog [(visible)]="showOdaAlert" [showHeader]="true" showappendTo="body" [modal]="true" [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '40vw'}" >
  <ng-template pTemplate="header">
    <div class="font-medium text-2xl text-900">Attenzione</div>
  </ng-template>
  <div class="flex flex-column align-items-right my-4">
    
    <p class="line-height-3 p-0 m-0">
        I seguenti Ordini di acquisto hanno un residuo inferiore al 10% del loro valore:
    </p>
    <ul class="m-0 p-0 ml-3">
      <li *ngFor="let oda of odaOltreSoglia" class="p-1"><span class="font-bold">{{ oda.numero }}</span> (importo residuo <span class="font-bold">{{oda.importoResiduo}}</span> €)</li>
    </ul>
</div>
<ng-template pTemplate="footer">
    <div class=" border-top-1 surface-border pt-3">
        <button pButton pRipple icon="pi pi-times" (click)="showOdaAlert = false" label="Chiudi" style="color: white; background-color: #3587A4; border-color: #3587A4;"></button>
    </div>
</ng-template>
</p-dialog>





<p-toast position="top-center"></p-toast>
